var $f4b51eff7a8489c2$exports = {};
$f4b51eff7a8489c2$exports = {
    "loading": `Loading...`,
    "noResults": `No results`,
    "clear": `Clear`,
    "invalid": `(invalid)`,
    "valid": `(valid)`
};


export {$f4b51eff7a8489c2$exports as default};
//# sourceMappingURL=en-US.mjs.map
